export interface Category {
  id: string;
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    id: 'cat-001',
    slug: 'comprehensive',
    name: '综合实力排名',
    description: '综合演技、票房、人气等多维度数据的全方面排行，反映女优的真实综合实力与行业地位。',
    icon: 'ri-award-line',
  },
  {
    id: 'cat-002',
    slug: 'popularity',
    name: '人气热度榜',
    description: '基于社交媒体关注度、搜索指数、粉丝互动等数据综合评定的人气热度排行榜。',
    icon: 'ri-fire-line',
  },
  {
    id: 'cat-003',
    slug: 'boxoffice',
    name: '票房成绩榜',
    description: '以作品销量、租赁数据、数字发行收入等核心指标为依据的票房成绩排名。',
    icon: 'ri-money-cny-circle-line',
  },
  {
    id: 'cat-004',
    slug: 'acting',
    name: '演技评分榜',
    description: '由专业影评人与资深观众共同评定的演技实力排名，聚焦表演艺术水准。',
    icon: 'ri-emotion-line',
  },
  {
    id: 'cat-005',
    slug: 'newcomer',
    name: '新人推荐榜',
    description: '2023年后出道的新人女优中表现最突出的排行，发掘明日之星。',
    icon: 'ri-star-line',
  },
];